import React from "react";
import ReactDOM from "react-dom/client";
import { WagmiProvider } from "wagmi";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RainbowKitProvider, darkTheme, AvatarComponent } from "@rainbow-me/rainbowkit";
import { BrowserRouter } from "react-router-dom";

import { wagmiConfig } from "@/lib/wagmi";
import { PiggyAvatar } from "@/components/PiggyAvatar";
import App from "./App";
import "./index.css";

const CustomAvatar: AvatarComponent = ({ address, ensImage, size }) => (
    <PiggyAvatar address={address} ensImage={ensImage} size={size} />
);

const queryClient = new QueryClient();

const piggyTheme = darkTheme({
    // Lime-primary brand: black-on-lime, never white-on-lime.
    accentColor: "#CCFF00",
    accentColorForeground: "#000000",
    borderRadius: "large",
    fontStack: "system",
    overlayBlur: "small",
});

ReactDOM.createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
        <WagmiProvider config={wagmiConfig}>
            <QueryClientProvider client={queryClient}>
                <RainbowKitProvider theme={piggyTheme} modalSize="compact" avatar={CustomAvatar}>
                    <BrowserRouter>
                        <App />
                    </BrowserRouter>
                </RainbowKitProvider>
            </QueryClientProvider>
        </WagmiProvider>
    </React.StrictMode>,
);
